import { createPortal } from 'react-dom'

export const PortalWrapper = ({
  container,
  children,
}: React.PropsWithChildren<{ container: React.MutableRefObject<HTMLElement | null> | null }>) => {
  if (container && container.current) {
    return createPortal(children, container.current)
  }

  return null
}
